import { Routes, Route } from "react-router-dom";
import { CssBaseline } from "@mui/material";

// pages
import HomePage from "../Pages/sitepages/HomePage";
import Test from "../Pages/sitepages/Test";
import MenuPage from "../Pages/sitepages/MenuPage";
import NotFoundPage from "../Pages/sitepages/NotFoundPage";

export default function SiteStack() {
  return (
    <>
      <CssBaseline />

      <div>
        {/* Scrollable content area */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/test" element={<Test />} />
          <Route path="/menu/:id" element={<MenuPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </>
  );
}
